import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ChevronDown, Plus, Check, Landmark, ShieldCheck } from "lucide-react";

export const OrgSwitcher = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/political-os/my-entities").then(r => setData(r.data)).catch(() => {});
  }, []);

  const active = data?.entities?.find(e => e.id === data.active_entity_id);

  const activate = async (e) => {
    try {
      await api.post(`/political-os/entities/${e.id}/activate`);
      toast.success(`Switched to ${e.public_campaign_name || e.legal_org_name}`);
      window.location.reload();
    } catch { toast.error("Could not switch organization"); }
  };

  if (!data) return null;

  return (
    <div className="relative px-3 pb-3">
      <button onClick={() => setOpen(o => !o)} data-testid="org-switcher"
        className="w-full flex items-center gap-2 px-3 py-2 rounded-xl border border-white/10 bg-white/[0.03] hover:border-cyan-400/40 transition-colors text-left">
        <Landmark className="w-4 h-4 text-cyan-300 shrink-0" />
        <span className="min-w-0 flex-1">
          <span className="block text-xs font-semibold text-white truncate">
            {active ? (active.public_campaign_name || active.legal_org_name) : "Select organization"}
          </span>
          <span className="block text-[9px] uppercase tracking-wider text-slate-500 truncate">
            {active ? (active.entity_type || "").replace(/_/g, " ") : "Who do you represent?"}
          </span>
        </span>
        <ChevronDown className={`w-3.5 h-3.5 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-3 right-3 top-full mt-1 bg-[#0d1322] border border-white/10 rounded-xl shadow-2xl overflow-hidden z-50" data-testid="org-switcher-menu">
          {data.entities.map(e => (
            <button key={e.id} onClick={() => activate(e)} data-testid={`org-option-${e.id}`}
              className="w-full text-left px-3 py-2.5 hover:bg-white/5 flex items-center gap-2 transition-colors">
              <span className="min-w-0 flex-1">
                <span className="block text-xs text-white truncate">{e.public_campaign_name || e.legal_org_name}</span>
                <span className="block text-[9px] text-slate-500 flex items-center gap-1">
                  {(e.entity_type || "").replace(/_/g, " ")}
                  {e.verification_summary?.score >= 85 && <ShieldCheck className="w-2.5 h-2.5 text-emerald-300" />}
                </span>
              </span>
              {e.id === data.active_entity_id && <Check className="w-3.5 h-3.5 text-cyan-300 shrink-0" />}
            </button>
          ))}
          <button onClick={() => navigate("/onboarding/political")} data-testid="add-organization-btn"
            className="w-full text-left px-3 py-2.5 hover:bg-white/5 flex items-center gap-2 text-cyan-300 text-xs border-t border-white/10 transition-colors">
            <Plus className="w-3.5 h-3.5" /> Add organization
          </button>
        </div>
      )}
    </div>
  );
};
